<template>
    <div>
        <block v-if="loading"></block>
        <v-row class="mx-1 mt-2">
            <v-col cols="12" md="3">
                <v-btn @click="showAccountingForm = true" class="btn-save">Seleccionar cuentas contables a filtrar</v-btn>
            </v-col>
            <v-col cols="12" md="9">
                <h3 class="mx-4">Cuenta(s) contable(s) seleccionada(s): {{ selectedAccountsLabel }}</h3>
            </v-col>
        </v-row>
        <v-row class="mx-1 mt-4">
            <v-col cols="12" style="z-index: 101;">
            <DateFilterNotSync ref="childRef" @filtered-loading="setLoading" @filter-error="handleFilterError" @filtered-data="getAccountData" @setStartDate="(value) => { search.startDate = value }" @setEndDate="(value) => { search.endDate = value }"
                :dataToFilter="accountData" :search="this.search" :filterEndpoint="getAccountingDetailDataByAccounts" />
            </v-col>
            <v-col cols="12 mt-4">
                <v-btn class="btn-save" style="margin-bottom: -50px; z-index: 100;" @click="onExportingToPdf()">Exportar a pdf</v-btn>
                <DxDataGrid 
                ref="dataGrid"
                :data-source="accountData" 
                @exporting="onExporting"
                :word-wrap-enabled="true" 
                :column-auto-width="true"
                :paging="{ enabled: false }" 
                style="max-height: 600px; width: 100%;"
                >   
                    <DxScrolling 
                    row-rendering-mode="virtual"  
                    showScrollbar="always"
                    useNative="false" />
                    <DxColumn v-if="showAccountColumns" caption="Código de Cuenta" cssClass="center-column" data-field="account_code" />
                    <DxColumn v-if="showAccountColumns" caption="Nombre de Cuenta" cssClass="left-column" data-field="account_description" />
                    <DxColumn caption="ID de la Partida" cssClass="center-column" data-field="ID_Accounting_item" />
                    <DxColumn caption="Fecha de la Partida" cssClass="center-column" data-field="accounting_entry_date" />
                    <DxColumn caption="Concepto" cssClass="left-column" data-field="concept" />
                    <DxColumn caption="Debe (USD)" data-field="Debe" cssClass="right-column" alignment="right" style="text-align: right !important;" />
                    <DxColumn caption="Haber (USD)" data-field="Haber" cssClass="right-column" alignment="right" style="text-align: right !important;"/>
                    <DxColumn caption="Saldo (USD)" data-field="balance" cssClass="right-column" alignment="right" style="text-align: right !important;" />
                    <DxSummary v-if="!showAccountColumns" :calculate-custom-summary="calculateTotals">
                        <DxTotalItem
                        column="account_description"
                        display-format="RESUMEN DE TOTALES ------>"
                        />
                        <DxTotalItem
                            name="Debe"
                            summary-type="custom"
                            :value-format="customCurrencyFormat"
                            display-format="${0}"
                            show-in-column="Debe"
                            cssClass="right-column"
                        />
                        <DxTotalItem
                            name="Haber"
                            summary-type="custom"
                            :value-format="customCurrencyFormat"
                            display-format="${0}"
                            show-in-column="Haber"
                            cssClass="right-column"
                        />
                        <DxTotalItem
                            name="balance"
                            summary-type="custom"
                            :value-format="customCurrencyFormat"
                            display-format="${0}"
                            show-in-column="balance"
                            cssClass="right-column"
                        />
                    </DxSummary>
                    <DxExport :enabled="true" :formats="['xlsx','pdf']" />
                </DxDataGrid>
            </v-col>
        </v-row>

        <v-dialog v-model="showAccountingForm" scrollable width="70%">
            <ExpenseDialog
            :win="win"
            :newAccountList="accountList"
            :newSelectedExpense="selectedExpense"
            :action="action"
            :multiSelect="true"
            :allowParentAccounts="true"
            @handleAction="handleAction"
            />
        </v-dialog>

        <alerts
        style="z-index: 20000 !important"
        v-if="alert.show"
        v-on:close_alert="closeAlert"
        v-on:accept_alert="acceptAlert"
        :properties="alert"
        >
        </alerts>
        <block v-if="loading" style="z-index: 201;"/>
    </div>
    
</template>

<script>
import Block from "@/components/Block";
import { DxDataGrid, DxScrolling, DxColumn, DxSummary, DxTotalItem, DxExport } from "devextreme-vue/data-grid";
import DateFilterNotSync from "@/components/DateFilterNotSync.vue";
import ExpenseDialog from "../ExpenseDialog.vue";
import { jsPDF } from 'jspdf'
import 'jspdf-autotable';
import { printToExcel } from "@/helpers/printToexcel";
import Alerts from "@/components/Alerts";

export default {
	name: "BalanceDetailByAccount",
	components: {
		Block,
        DxDataGrid,
        DxScrolling,
        DateFilterNotSync,
        ExpenseDialog,
        DxColumn,
        DxSummary,
        DxTotalItem,
        DxExport, 
        Alerts
	},
	props: ['win'],
	data() {
		return {
            loading: false,
            search: {},
            accountData: [],
            accountGroups: [],
            accountList: [],
            selectedAccounts: [],
            resolvedDetailAccounts: [],
            selectedExpense: {
                ExpenseName: null,
                ID: null,
                CatalogName: null,
            },
            showAccountingForm: false,
            action: {
                ADD: true,
                EDIT: false,
                DEL: false,
            },
            expenseIdCounter: 1,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            businessName: JSON.parse(localStorage.getItem('user'))?.business || '',
        }
    },
    mounted() {
        this.getAllAcounts();
    },
    watch: {
    },
    computed: {
        selectedAccountsLabel() {
            if (this.selectedAccounts.length === 0) {
                return "Ninguna";
            }

            if (this.selectedAccounts.length === 1) {
                const [account] = this.selectedAccounts;
                return [account.account_code, account.account_description].filter(Boolean).join(" - ");
            }

            return `${this.selectedAccounts.length} cuentas seleccionadas`;
        },
        showAccountColumns() {
            return this.resolvedDetailAccounts.length > 1;
        },
    },
    methods: {
        setLoading(loadingStatus){
            this.loading = loadingStatus
        },
        parseMoney(value) {
            if (value === null || value === undefined || value === "") return 0;
            if (typeof value === "number") return isNaN(value) ? 0 : value;

            const parsedValue = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
            return isNaN(parsedValue) ? 0 : parsedValue;
        },
        calculateTotals( options ) {
            try {
                if (options.name === 'Debe') {
                    if (options.summaryProcess === 'start') {
                        options.totalValue = 0;
                    }

                    if (options.summaryProcess === 'calculate') {
                        options.totalValue += this.parseMoney( options.value.Debe );
                    }
                } else if( options.name === 'Haber' ) {
                        
                    if (options.summaryProcess === 'start') {
                        options.totalValue = 0;
                    }
                    
                    if (options.summaryProcess === 'calculate') {
                        options.totalValue += this.parseMoney( options.value.Haber );
                    }
                } else if ( options.name === 'balance' ) {
                    if (options.summaryProcess === 'start') {
                        options.totalValue = 0;
                    }
                    
                    if (options.summaryProcess === 'calculate') {
                        const lastRow = this.accountData[ this.accountData.length - 1 ];
                        options.totalValue = lastRow ? this.parseMoney( lastRow.balance ) : 0;
                    }
                }
            } catch (error) {
                console.log( error );
            }
        },
        customCurrencyFormat(value) {
            if (value == null) return '';
            return this.formatAmount(value);
        },
        async handleAction({ action, ...data } = {}) {
            this.showAccountingForm = false
            if(!action) return;

            if(action === "error") {
                this.showAlert("warning", "Advertencia", "Código contable seleccionado es invalido.")
            }
            else {
                const selectedAccounts = Array.isArray(data.Accounts)
                    ? data.Accounts
                    : this.getSingleSelectedAccount(data);

                if(selectedAccounts.length === 0) {
                    this.showAlert("warning", "Advertencia", "Seleccione al menos una cuenta contable.")
                    return;
                }

                this.selectedAccounts = selectedAccounts;
                this.resolvedDetailAccounts = this.resolveDetailAccounts(selectedAccounts);

                if(this.resolvedDetailAccounts.length === 0) {
                    this.accountData = [];
                    this.accountGroups = [];
                    this.showAlert("warning", "Advertencia", "Las cuentas seleccionadas no tienen cuentas de detalle asociadas.")
                    return;
                }

                this.search.accountcode = this.resolvedDetailAccounts.map((account) => account.account_code).join(", ")
                this.search.accountcodes = JSON.stringify(this.resolvedDetailAccounts.map((account) => account.account_code))
                this.search.catalogname = this.selectedAccountsLabel
                this.alert.show = false
                this.loading = true
                await this.$nextTick();

                try {
                    await this.$refs.childRef.filterData();
                } catch (error) {
                    this.handleFilterError(error);
                } finally {
                    this.loading = false;
                }
                
                
            }
        },
        getAllAcounts() {
            try {
                this.$API.branchaccountcatalog
                .getActiveBranchAccountCatalog()
                .then(({ data }) => {
                    this.accountList = data;
                });
            } catch (error) {
                console.log(error);
            }
        },
        getSingleSelectedAccount(data) {
            if(!data.ID_AccountCatalog) return [];

            return [{
                id_account: data.ID_AccountCatalog,
                account_code: data.AccountCode,
                account_description: data.CatalogName,
                SelectedItem: true,
                allow_transactions: 1,
            }];
        },
        isDetailAccount(account) {
            return account?.SelectedItem === true
                || account?.SelectedItem === 1
                || account?.SelectedItem === "1"
                || account?.allow_transactions === true
                || account?.allow_transactions === 1
                || account?.allow_transactions === "1";
        },
        getDetailDescendants(account, visited = new Set()) {
            const accountId = account?.id_account;
            if(!accountId || visited.has(accountId)) return [];

            visited.add(accountId);

            return this.accountList
                .filter((current) => String(current.id_parent) === String(accountId))
                .reduce((detailAccounts, child) => {
                    if(this.isDetailAccount(child)) {
                        detailAccounts.push(child);
                    }

                    return detailAccounts.concat(this.getDetailDescendants(child, visited));
                }, []);
        },
        resolveDetailAccounts(accounts) {
            const detailAccountsMap = new Map();

            accounts.forEach((account) => {
                const detailAccounts = this.isDetailAccount(account)
                    ? [account]
                    : this.getDetailDescendants(account);

                detailAccounts.forEach((detailAccount) => {
                    const key = detailAccount.id_account || detailAccount.account_code;
                    if(key && !detailAccountsMap.has(key)) {
                        detailAccountsMap.set(key, detailAccount);
                    }
                });
            });

            return Array.from(detailAccountsMap.values())
                .sort((accountA, accountB) => String(accountA.account_code).localeCompare(String(accountB.account_code)));
        },
        async getAccountingDetailDataByAccounts(search) {
            this.resolvedDetailAccounts = this.resolveDetailAccounts(this.selectedAccounts);

            if(this.selectedAccounts.length === 0) {
                this.accountData = [];
                this.accountGroups = [];
                this.showAlert("warning", "Advertencia", "Seleccione al menos una cuenta contable.")
                return [];
            }

            if(this.resolvedDetailAccounts.length === 0) {
                this.accountData = [];
                this.accountGroups = [];
                this.showAlert("warning", "Advertencia", "Las cuentas seleccionadas no tienen cuentas de detalle asociadas.")
                return [];
            }

            const accountcodes = this.resolvedDetailAccounts.map((account) => account.account_code);
            const accountGroups = await this.$API.accountingreports.getAccountingDetailDataByAccounts({
                ...search,
                accountcodes: JSON.stringify(accountcodes),
            });

            this.accountGroups = this.normalizeAccountGroups(accountGroups, this.resolvedDetailAccounts);
            return this.flattenAccountGroups(this.accountGroups);
        },
        normalizeAccountGroups(accountGroups, detailAccounts) {
            const accountGroupsMap = new Map(
                (accountGroups || []).map((group) => [group.account_code, group])
            );

            return detailAccounts.map((account) => {
                const group = accountGroupsMap.get(account.account_code) || {};
                const movements = Array.isArray(group.movements) ? group.movements : [];

                return {
                    account_code: account.account_code,
                    account_description: group.account_description || account.account_description || "",
                    movements,
                    totals: group.totals || this.getGroupTotals(movements),
                };
            });
        },
        getGroupTotals(movements) {
            const totals = movements.reduce((acc, movement) => {
                acc.debe += this.parseMoney(movement.Debe);
                acc.haber += this.parseMoney(movement.Haber);
                return acc;
            }, {
                debe: 0,
                haber: 0,
                balance: 0,
            });

            if(movements.length > 0) {
                totals.balance = this.parseMoney(movements[movements.length - 1].balance);
            }

            return totals;
        },
        flattenAccountGroups(accountGroups) {
            return accountGroups.reduce((rows, group) => {
                const accountData = {
                    account_code: group.account_code,
                    account_description: group.account_description,
                    account_label: [group.account_code, group.account_description].filter(Boolean).join(" - "),
                };

                if(group.movements.length === 0) {
                    rows.push({
                        ...accountData,
                        ID_Accounting_item: "",
                        accounting_entry_date: "",
                        concept: "Sin movimientos en el rango seleccionado.",
                        Debe: "0.00",
                        Haber: "0.00",
                        balance: this.formatAmount(group.totals?.balance),
                    });
                    return rows;
                }

                group.movements.forEach((movement) => {
                    rows.push({
                        ...movement,
                        ...accountData,
                    });
                });

                return rows;
            }, []);
        },
        getAccountData(filteredData) {
            this.accountData = filteredData
            //this.loading = false
        },
        handleFilterError(errorMessage) {
            this.loading = false;
            this.accountData = [];
            this.accountGroups = [];
            this.showAlert(
                "danger",
                "Problema de conexión",
                typeof errorMessage === "string" && errorMessage.length > 0
                    ? errorMessage
                    : "No se pudo consultar el detalle por un problema de conexión. Verifique su internet e intente nuevamente."
            );
        },
        formatAmount(value) {
            return this.parseMoney(value).toFixed(2);
        },
        onExporting(e) {
            //let array = null;
            //array = ["saldo_anterior"]
            const fileName = [
                'Reporte de cuenta contable',
                this.selectedAccountsLabel,
                this.businessName,
            ].filter(Boolean).join(' - ');

            printToExcel(e, fileName, null, "Reporte de cuenta contable", true, true, this.selectedAccountsLabel);
        },
        onExportingToPdf() {
            if(this.selectedAccounts.length === 0) {
                this.showAlert("warning", "Advertencia", "Seleccione al menos una cuenta contable.")
                return;
            }

            if(this.accountGroups.length === 0) {
                this.showAlert("warning", "Advertencia", "Busque movimientos antes de exportar el reporte.")
                return;
            }

            const doc = new jsPDF();
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const pageTopMargin = 24;
            const pageBottomMargin = 18;
            let currentY = pageTopMargin;
            const bordesTabla = 0.02;
            const colorBordesTabla = [190, 190, 190];
            this.accountGroups.forEach((group, index) => {
                if(index > 0 && currentY > pageHeight - 50) {
                    doc.addPage();
                    currentY = pageTopMargin;
                }

                const accountTitle = [group.account_code, group.account_description].filter(Boolean).join(" - ");
                doc.setFontSize(9);
                doc.setFont("helvetica", "bold");
                doc.text(accountTitle, 14, currentY);
                doc.setFont("helvetica", "normal");

                const body = group.movements.length > 0
                    ? group.movements.map((movement) => ([
                        movement.ID_Accounting_item || "",
                        movement.accounting_entry_date || "",
                        movement.concept || "",
                        this.formatAmount(movement.Debe),
                        this.formatAmount(movement.Haber),
                        this.formatAmount(movement.balance),
                    ]))
                    : [[ "", "", "Sin movimientos en el rango seleccionado.", "0.00", "0.00", this.formatAmount(group.totals?.balance) ]];

                body.push([
                    "",
                    "",
                    "TOTAL CUENTA",
                    this.formatAmount(group.totals?.debe),
                    this.formatAmount(group.totals?.haber),
                    this.formatAmount(group.totals?.balance),
                ]);

                doc.autoTable({
                    startY: currentY + 4,
                    head: [[
                        "ID de la Partida",
                        "Fecha de la Partida",
                        "Concepto",
                        "Debe (USD)",
                        "Haber (USD)",
                        "Saldo (USD)",
                    ]],
                    body,
                    theme: "grid",
                    margin: { top: pageTopMargin, bottom: pageBottomMargin },
                    tableLineColor: colorBordesTabla,
                    tableLineWidth: bordesTabla,
                    styles: {
                        fontSize: 7,
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        lineColor: colorBordesTabla,
                        lineWidth: bordesTabla,
                    },
                    headStyles: {
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        lineColor: colorBordesTabla,
                        lineWidth: bordesTabla,
                    },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    columnStyles: {
                        2: { cellWidth: 70 },
                        3: { halign: "right" },
                        4: { halign: "right" },
                        5: { halign: "right" },
                    },
                    didParseCell: function (data) {
                        if(data.row.index === body.length - 1) {
                            data.cell.styles.fontStyle = "bold";
                        }
                    },
                });

                currentY = doc.lastAutoTable.finalY + 10;
            });

            const pageCount = doc.internal.getNumberOfPages();
            const header = `${JSON.parse(localStorage.getItem("user")).business}`;
            const header2 = `Balance de Detalle por Cuenta(s) Desde ${ this.search.startDate } Hasta ${ this.search.endDate }`;

            for(let i = 1; i <= pageCount; i++){
                doc.setPage(i);

                doc.setFontSize(7)
                doc.text('page:  ' + i + ' / ' + pageCount, 10, 10);

                const headerWidth = doc.getTextDimensions(header).w;
                const headerWidth2 = doc.getTextDimensions(header2).w;
                doc.setFontSize(10);
                doc.text(header, (pageWidth - headerWidth) / 2, 8);
                doc.setFontSize(7);
                doc.text(header2, (pageWidth - headerWidth2) / 2, 13);
            }

            doc.save('Reporte de balance de detalle por cuenta.pdf');
        },
        closeAlert() {
            this.alert.show = false;
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },   
    }
}
</script>

<style>
  .dx-datagrid-headers .dx-datagrid-table .dx-row .right-column {
    text-align: center !important;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .left-column {
    text-align: center !important;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .center-column {
    text-align: center !important;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .right-column {
    text-align: right !important;
    font-size: 10px;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .left-column {
    text-align: left !important;
    font-size: 10px;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .center-column {
    text-align: center !important;
    font-size: 10px;
}

</style>
